import {AxiosError} from 'axios';
import {GET_ACCOUNT_MANAGEMENT_ACTION_TYPES_QUERY_KEY} from 'web-library/constants/queryKeys';
import {GET_ACCOUNT_MANAGEMENT_ACTION_TYPES_URL} from 'web-library/constants/apiUrls';
import {
  AccountManagementActionTypesResponseObject
} from 'web-library/models/AccountManagementConfiguration';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: AccountManagementActionTypesResponseObject[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetAccountManagementActionTypes = ({onError, onSuccess}: Input = {}) => {
  const getAccountManagementActionTypes = async () => {
    const res = await axiosClient.get<AccountManagementActionTypesResponseObject[]>(
        GET_ACCOUNT_MANAGEMENT_ACTION_TYPES_URL
    );

    return res.data;
  };

  return useCustomQuery(
      GET_ACCOUNT_MANAGEMENT_ACTION_TYPES_QUERY_KEY,
      getAccountManagementActionTypes,
      {
        onSuccess,
        onError,
        enabled: false,
      }
  );
};
